import colors from 'globals/colors'
import measures from 'globals/measures'
import styled from 'styled-components'

export const TemplateWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  
  @media(max-width: ${measures.tabletThreshold}px) {
    flex-direction: column;
  } 
`

interface TemplateContentProps {
  noPadding: boolean,
  noScroll: boolean
}

export const TemplateContent = styled.div<TemplateContentProps>`
  height: 100%;
  color: ${colors.darkGrey};
  background: ${colors.lighterGrey};
  padding: 50px 48px;
  flex: 1;
  overflow-y: ${(props) => props.noScroll ? 'auto' : 'scroll'};
  
  ${(props) => props.noPadding && `
    padding: 0;
  `};

  @media(max-width: ${measures.mobileThreshold}px) {
    padding: 16px 24px;
    
    ${(props) => props.noPadding && `
      padding: 0;
    `};
   }
`
